<template>
  <div class="container px-4 mb-5 pb-5 z-depth-1 about-call">
    <!--Section: Content-->
    <section class="px-md-5 mx-md-5 text-center text-lg-left">
      <h3 class="font-weight-bold fall-down">
        Investissez dans votre logistique, pas dans les allers-retours.
      </h3>

      <p class="mb-5 text-center fall-down">
        En choisissant <span class="color-primary">Livratos</span>, vous ne
        faites pas qu’<strong>organiser des livraisons</strong>. Vous récupérez
        des heures de production sur <strong>chantier</strong>, vous fluidifiez
        vos dépôts matériaux et vous offrez un meilleur service à vos clients
        pros.
      </p>

      <!--Grid row-->
      <div class="row my-5 py-5">
        <!--Grid column-->
        <div class="col-12 col-lg-6 mb-lg-0 mb-4 slide-left">
          <img
            src="@/assets/pictures/login-mockup.webp"
            class="img-fluid"
            alt="Interface Livratos sur mobile et desktop"
          />
        </div>
        <!--Grid column-->

        <!--Grid column-->
        <div class="col-12 col-lg-6 mb-lg-0 mb-2 slide-right">
          <h4 class="my-4">Envie d’en voir plus&nbsp;?</h4>

          <p class="mb-5">
            Vous voulez tester Livratos sur vos propres
            <strong>chantiers</strong>&nbsp;? Découvrez comment une plateforme
            dédiée au <strong>BTP</strong> peut prendre en charge vos
            <strong>livraisons express</strong> et <strong>programmées</strong>,
            réduire les déplacements inutiles et sécuriser chaque course, du
            dépôt au <strong>dernier kilomètre</strong>.
          </p>
          <div class="text-center text-lg-start btn-group-cta">
            <button
              class="btn btn-md waves-effect mr-2"
              type="button"
              @click="showStartModal = true"
            >
              Découvrir Livratos
            </button>
            <a class="btn btn-md" href="/contact" role="button">
              Parler à l’équipe
              <i class="fa fa-magic ml-1"></i>
            </a>
          </div>
        </div>
        <!--Grid column-->
      </div>
      <!--Grid row-->
    </section>
    <!--Section: Content-->

    <transition name="fade">
      <div
        v-if="showStartModal"
        class="start-modal-overlay"
        @click.self="showStartModal = false"
      >
        <div class="start-modal">
          <button class="start-modal__close" @click="showStartModal = false">
            &times;
          </button>

          <h2 class="start-modal__title">Choisissez votre profil</h2>
          <p class="start-modal__subtitle">
            Sélectionnez votre rôle pour accéder à la page dédiée.
          </p>

          <div class="start-modal__grid">
            <router-link
              class="start-modal__card"
              :to="{ name: 'Fournisseur' }"
              @click="showStartModal = false"
            >
              <div class="start-modal__icon bg-stock"></div>
              <h3>Fournisseur BTP</h3>
            </router-link>

            <router-link
              class="start-modal__card"
              :to="{ name: 'Livrateur' }"
              @click="showStartModal = false"
            >
              <div class="start-modal__icon bg-livraison"></div>
              <h3>Livreur indépendant</h3>
            </router-link>

            <router-link
              class="start-modal__card"
              :to="{ name: 'Artisans' }"
              @click="showStartModal = false"
            >
              <div class="start-modal__icon bg-eco"></div>
              <h3>Artisan</h3>
            </router-link>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "AboutCallAction",
  data() {
    return {
      showStartModal: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.color-primary {
  color: $color-primary;
}

.about-call {
  background-color: $background;
  margin-top: 150px;

  h3 {
    color: $color-text;
  }

  p {
    color: $color-text-grey;
  }

  h4 {
    color: $color-primary;
  }

  .btn-group-cta a,
  .btn-group-cta button {
    border-radius: 5px;
    font-weight: 500;
    border: 1px solid $color-primary;
  }

  .btn-group-cta button {
    background-color: $color-primary;
    color: #000;
    margin-right: 10px;

    &:hover {
      background-color: darken($color-primary, 10%);
      color: #fff;
      border-color: darken($color-primary, 10%);
    }
  }

  .btn-group-cta a:last-child {
    background-color: transparent;
    color: $color-primary;
    border-color: $color-primary;

    &:hover {
      background-color: $color-darker;
      color: #fff;
      border-color: $color-darker;
    }
  }
}

.start-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.start-modal {
  background: #ffffff;
  border-radius: 16px;
  padding: 28px 22px;
  max-width: 880px;
  width: 92%;
  position: relative;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.35);
}

.start-modal__close {
  position: absolute;
  top: 10px;
  right: 14px;
  background: transparent;
  border: none;
  font-size: 26px;
  cursor: pointer;
  line-height: 1;
}

.start-modal__title {
  text-align: center;
  margin-bottom: 6px;
  font-size: 1.4rem;
  font-weight: 700;
  color: #111;
}

.start-modal__subtitle {
  text-align: center;
  margin-bottom: 22px;
  font-size: 0.95rem;
  color: #555;
}

.start-modal__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
}

.start-modal__card {
  background: #f5f5f5;
  border-radius: 12px;
  padding: 18px 12px 20px;
  text-align: center;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease,
    background-color 0.18s ease, border-color 0.18s ease;
  border: 1px solid transparent;

  &:hover {
    transform: translateY(-4px);
    background-color: #ffffff;
    border-color: $color-primary;
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.22);
  }

  h3 {
    margin-top: 10px;
    font-size: 1rem;
    font-weight: 600;
    color: #111;
  }
}

.start-modal__icon {
  width: 72px;
  height: 72px;
  margin: 0 auto;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.bg-livraison {
  background-image: url("@/assets/icons/icon-livreur.webp");
}

.bg-stock {
  background-image: url("@/assets/icons/icon-fournisseur.webp");
}

.bg-eco {
  background-image: url("@/assets/icons/icon-artisan.webp");
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
::contentReference[oaicite:0]{index=0}
